import React from "react";
import { Helmet } from "react-helmet";

// This component is no longer used - 9Wicket launches directly in iframe
// The game is launched from the sidebar using the useGameLaunch hook
// See SkylaSidebar.js handle9WicketClick() for the launch logic

const NineWicketIndex = () => {
  return (
    <>
      <Helmet>
        <title>9Wicket - Sports Betting</title>
        <meta name="keywords" content="9Wicket, Sports Betting, Cricket, Football, Basketball" />
        <meta name="description" content="Play 9Wicket Sports Betting Games" />
        <link rel="canonical" href="/9wicket" />
      </Helmet>
      <div style={{ padding: '20px', color: 'white' }}>
        <p>9Wicket is loading...</p>
      </div>
    </>
  );
};

export default NineWicketIndex;
